module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "guide",
    attrs: {
      "id": "guide"
    }
  }, [
    [_c('div', {
      staticClass: "g1",
      attrs: {
        "id": "g1"
      }
    }, [_c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.next(1)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "g2",
      attrs: {
        "id": "g2"
      }
    }, [_c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.next(2)
        }
      }
    })])]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70dfa910"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Guide/Guide.vue
// module id = 522
// module chunks = 1